import { render } from "./ActivityButton.vue?vue&type=template&id=4ccf52f7&scoped=true"
import script from "./ActivityButton.vue?vue&type=script&lang=js"
export * from "./ActivityButton.vue?vue&type=script&lang=js"

import "./ActivityButton.vue?vue&type=style&index=0&id=4ccf52f7&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccf52f7"]])

export default __exports__